import React, { PureComponent } from 'react';
import relationInput from './hoc/relationHoc';
import FormCore from '@/components/display/form/formCore';
import PropTypes from 'prop-types';
import moment from 'moment';
import { initModals } from '../../../../state/action/comAction';
import { getRoleList, getUserList,getCityList } from '../../../../fetch/fetchApi';
// import { alilogStore, faultTypeList } from '../../../../fetch/fetchApi';
import { systemLogsForSdk } from '../../../../utils/aliconfig';
import asyncRelationSelect from '../../../../hoc/form/asyncRelationSelect';
import CityDataFilterHoc from '../../../../hoc/form/cityDataHoc';
import monthPickerHoc from '../../../../hoc/form/monthPickerHoc';


@relationInput
@asyncRelationSelect
@CityDataFilterHoc
@monthPickerHoc
class VertForm extends PureComponent {
	constructor (props) {
		super(props);
		this.props = props;
		this.layout = [
			'inline', // 横向布局
			'horizontal' // 纵向布局
		];
		this.state = {
			options: []
		};
	}
	
	static contextTypes = {
		store: PropTypes.object.isRequired
	};
	
	componentWillMount () {
		// 配置formItem的构建信息
		let projectOptions = systemLogsForSdk.map((systemLog, i) => {
			return { text: systemLog.application, value: systemLog.logger };
		});
		this.formConfig = {
			childItems: [
				{
					type: 'birthdayDate',
					param: {
						name: 'birthdayStart', // 提交的参数
						type: 'array'
					},
					labelName: '生日开始日期',
					placeholder: '不可用于设置值，仅用于作为查询',
					required: !1,
					displayRender:(label, selectedOptions)=> label.join('-')//自定义日期渲染的格式
				},
				{
					type: 'birthdayDate',
					param: {
						name: 'birthdayEnd', // 提交的参数
						type: 'array'
					},
					labelName: '生日结束日期',
					placeholder: '请输入内容',
					required: !1,
					displayRender:(label, selectedOptions)=> label.join('/')//自定义日期渲染的格式
				},
				{
					param: {
						name: 'project',
						type: 'string'
					},
					defaultValue:'',
					required: !0,
					labelName: '日志类型',
					plugin: this.props.relationSelect[0]('级联下拉单选',projectOptions,'project','logstorename')
				},
				{
					param: {
						name: 'city', //与form表单绑定的参数名
						type: 'array'
					},
					// defaultValue: ['34'], //默认值
					required: !1,
					labelName: '地区(只传最后的一个code)',
					format: this.props.format, //数据格式化之后给formcore
					plugin: this.props.cityDataFilter[0]('请选择地区', 'city', false) //最后一个参数指是否显示到区
				},
				{
					type: 'input', // 定义表单元素基础类型
					inputType: 'text', // 定义表单元素的子类型
					param: { // 定义表单元素的参数对象
						name: 'stubGroupId', // 参数名称
						type: 'string' // 参数类型，用来做类型检测
					},
					labelName: '桩群ID', // label名称
					defaultValue: '20170913021', // 设置默认值，同设置disabled则不能修改
					disabled: true, // 功能类似于defaultParams
					radio: { // 设置参数选择器， checked为true则会封装到提交参数对象中
						radioGroup: 'only', // radioGroup 为选择组，相同的radioGroup为一组
						checked: !0
					}
				},
				{
					type: 'autoWatch',
					param: {
						name: 'autoRoles', // 提交的参数
						type: 'string'
					},
					labelName: '自动联想',
					placeholder: '请输入内容',
					required: !1,
					showParam: 'title', // 展示的条目参数,如果是字符串数组，就直接不设置
					choseParam: 'id', // 选中的参数，如果是字符串数组，就直接不设置
					sourceApi: getRoleList // 选项接口
				},
				{
					type: 'select',
					labelName: '所属类别',
					param: {
						name: 'type',
						type: 'number'
					},
					options: [
						{ c_name: '全部', c_id: null }
					],
					placeholder: '请选择类型',
					defaultValue: null,
					required: !1,
					mapKey: {
						text: 'c_name',
						value: 'c_id'
					},
					fetchQuery: {
						code: '351'
					},//异步select请求参数
					dataApi: {
						// api: faultTypeList,
						loaded: !1
					}
				},
				{
					width: 300,
					param: {
						name: 'relationVal',
						type: 'string'
					},
					defaultValue: '关联input',
					required: !1,
					labelName: '关联Input',
					// 这里对自定义HOC进行传参
					plugin: this.props.relationInput[ 0 ]('关联', 'relationChild'),
					// 禁用规则
					disabledRule: (disabledObj) => {
						return disabledObj[ 'stubType' ] === '1' && disabledObj[ 'selectInfo' ] === '1';
					}
				}, {
					width: 400,
					param: {
						name: 'relationChild',
						type: 'string'
					},
					required: !1,
					labelName: '被关联的Input',
					plugin: this.props.relationInput[ 1 ]('被关联'),
					// 禁用规则
					disabledRule: (disabledObj) => {
						return disabledObj[ 'stubType' ] === '1' && disabledObj[ 'selectInfo' ] === '1';
					}
				},
				{
					width: 400,
					param: {
						name: 'hocSelect',
						type: 'string'
					},
					labelName: 'hoc影响内核',
					defaultValue: '1',
					plugin: this.props.relationInput[ 2 ]('请切换', 'hocSelect')
				},
				{
					width: 300,
					param: {
						name: 'tipVal',
						type: 'string'
					},
					labelName: '带Tip提示',
					plugin: this.props.relationInput[ 3 ](),
					newLine: !0
				},
				{
					type: 'lazyOption', // 异步级联选择
					param: {
						name: 'lazyParams',
						type: 'array'
					},
					labelName: '异步级联',
					placeholder: '请选择',
					required: !1,
					optionsName: 'name', // 定义每层选项的显示文字参数
					optionsInitValue: '123', // 初始选项的请求参数
					optionsValue: 'id', // 定义每层选项的value
					optionsParam: 'reqId', // 定义请求每层选项的参数
					optionsApi: getUserList,
					optionsLimit: 3 // 定义级联的层数
				},{
					type: 'areaPicker', // 地区选择组件
					isPickArea: !1, // 设置是否需要选择到区一级
					placeholder: '请选择安装地区',
					defaultValue: [ '11', '1101' ],
					pickOnSelect: true, //是否选择即改变
					param: {
						name: 'city',
						type: 'array'
					},
                    mapKey:{
                        label:'label',
                        value:'value',
                        children:'children'
                    },
					required: !1, // 注意带有条件radio的formItem，不可以设置为必填
					labelName: '安装地区1',
					className: 'allshow',
					radio: {
						radioGroup: 'only',
						checked: !1
					},
					width: 400,
                    sourceApi:getCityList,
				},
				{
					type: 'areaPicker', // 地区选择组件
					isPickArea: !0, // 设置是否需要选择到区一级
					placeholder: '请选择安装地区',
					defaultValue: [ '11', '1101' ],
					pickOnSelect: true, //是否选择即改变
					param: {
						name: 'city',
						type: 'array'
					},
                    mapKey:{
                        label:'label',
                        value:'value',
                        children:'children'
                    },
					required: !1, // 注意带有条件radio的formItem，不可以设置为必填
					labelName: '安装地区',
					className: 'allshow',
					radio: {
						radioGroup: 'only',
						checked: !1
					},
					width: 400,
                    sourceApi:getCityList,
				},

				{
					type: 'radio',
					labelName: '电桩类型',
					param: {
						name: 'stubType',
						type: 'string'
					},
					options: [
						{
							text: '公桩',
							value: '0'
						},
						{
							text: '私桩',
							value: '1'
						}
					],
					defaultValue: '0',
					required: !1
				},
				{
					type: 'input',
					inputType: 'text',
					placeholder: '我由对应信息控制显示',
					param: {
						name: 'username',
						type: 'string'
					},
					required: !1,
					validator: { // 自定义校验对象
						vtype: 'length', // 校验名称
						min_val: 4, // 规则参数
						max_val: 20
					},
					labelName: '报修人',
					// 显示规则
					visibleRule: (visibleObj) => {
						return visibleObj[ 'hocSelect' ] === '0';
					}
				},
				{
					width: '100%',
					param: {
						name: 'month',
						type: 'object'
					},
					defaultValue: moment(new Date(), 'YYYY-MM'),
					required: !1,
					labelName: '月份选择',
					format: this.props.format,
					plugin: this.props.monthPicker[0]('月份选择', 'month')
				},
				{
					type: 'date',
					dateType: 'rangeMonth',
					placeholder: [ '开始月份', '结束月份' ],
					param: {
						name: 'date',
						type: 'array'
					},
					defaultValue: [ moment(new Date()).subtract(1, 'M'), moment(new Date()) ],
					labelName: '月份范围',
					required: !1
				},
				{
					type: 'date',
					dateType: 'pickDate',
					placeholder: '请选择安装日期',
					param: {
						name: 'installDate',
						type: 'object'
					},
					defaultValue: moment('2018-09-09'), // 设置默认日期
					range: [ 3, 0 ], // 3 为从今天往前推3天， 0 为今天
					labelName: '安装日期',
					required: !1
				},
				{
					type: 'date',
					dateType: 'pickDateTime',
					placeholder: '我由电桩类型控制',
					param: {
						name: 'installDateTime',
						type: 'object'
					},
					labelName: '日期带时间',
					visibleRule: {
						name: 'stubType',
						value: '1' // 设置显示规则，根据触发组件的paramName的变化来设置规则
					}
				},
				{
					type: 'date',
					dateType: 'rangeDate',
					placeholder: '请选择日期范围',
					param: {
						name: 'dateScope',
						type: 'array'
					},
					range: [ -2, -18 ], // 默认选择区域范围（从当天往后的2天到18天）
					validator: { // 自定义校验对象
						vtype: 'date', // 校验名称
						min_val: 2, // 可选最小天数
						max_val: 7 // 可选最大天数
					},
					labelName: '日期范围',
					required: !1
				},
				{
					type: 'date',
					dateType: 'rangeDate',
					placeholder: '请选择日期范围',
					param: {
						name: 'dateScope1',
						type: 'array'
					},
					defaultRanges: { '80年代': [ moment('1980-01-01'), moment('1980-01-31') ] },
					//range: [-2, -18], // 默认选择区域范围（从当天往后的2天到18天）
					// validator: { // 自定义校验对象
					// 	vtype: 'date', // 校验名称
					// 	min_val: 2, // 可选最小天数
					// 	max_val: 7 // 可选最大天数
					// },
					labelName: '预设年份日期范围',
					required: !1
				},
				// {
				//   type: 'date',
				//   dateType: 'rangeDateTime',
				//   param: {
				//     name: 'dateScopeTime',
				//     type: 'array'
				//   },
				//   labelName: '日期范围带时间',
				//   radio: {
				//     radioGroup: 'only2', // 设置选择组
				//     checked: !1
				//   },
				//   newLine: !0 // 是否强制换行
				// },
				{
					type: 'input',
					inputType: 'tel',
					placeholder: '请输入手机号码',
					param: {
						name: 'phone',
						type: 'string'
					},
					validator: {
						vtype: 'phone'
					},
					labelName: '联系电话',
					radio: {
						radioGroup: 'only2',
						checked: !0
					}
				},
				{
					type: 'select',
					options: [
						{
							text: '小明',
							value: '1'
						},
						{
							text: '小黄',
							value: '2'
						}
					],
					placeholder: '请选择对应信息',
					param: {
						name: 'selectInfo',
						type: 'string'
					},
					defaultValue: '1',
					required: !1,
					labelName: '对应信息'
				},
				{
					type: 'select',
					selectType: 'multiple', // 可用于替代checkbox
					placeholder: '请选择多个项目',
					param: {
						name: 'projectNames',
						type: 'array'
					},
					required: !1,
					labelName: '对应项目',
					options: [
						{
							text: 'oms',
							value: '1'
						},
						{
							text: 'saas',
							value: '2'
						},
						{
							text: 'app',
							value: '3'
						}
					]
				},
				{
					type: 'input',
					inputType: 'text',
					placeholder: '请输入code',
					labelName: '验证码',
					width: 500,
					defaultValue: '18686184125',
					param: {
						name: 'telCode',
						type: 'string'
					},
					required: !1,
					button: { // form元素后带单独执行的按钮并定义执行函数
						name: '获取信息',
						style: 'primary',
						loading: !1,
						handler: (e, obj, context) => {
							const loadingStatus = {};
							loadingStatus[ 'telCode_loading' ] = !0;
							context.setState(loadingStatus);
							// fetchHandler(searchUserInfo, { c_phone: obj.input.value }).then((res) => {
							// 	if (res.code === 'success') {
							// 		const userinfo = res.data[ 0 ];
							// 		userinfo ? context.props.form.setFieldsValue({
							// 				c_cartype: userinfo.c_cartype,
							// 				c_address: userinfo.c_address,
							// 				c_name: userinfo.c_name
							// 			}) :
							// 			context.props.form.setFieldsValue({
							// 				c_cartype: '',
							// 				c_address: '',
							// 				c_name: ''
							// 			});
							// 	}
							// 	loadingStatus[ 'telCode_loading' ] = !1;
							// 	context.setState(loadingStatus);
							// });
						}
					},
					newLine: !0
				},
				{
					type: 'input',
					inputType: 'text',
					placeholder: '--',
					labelName: '类型',
					param: {
						name: 'c_cartype',
						type: 'string'
					},
					required: !1
				},
				{
					type: 'input',
					inputType: 'text',
					placeholder: '--',
					labelName: '名称',
					param: {
						name: 'c_name',
						type: 'string'
					},
					required: !1
				},
				{
					type: 'input',
					inputType: 'text',
					placeholder: '--',
					labelName: '地址',
					param: {
						name: 'c_address',
						type: 'string'
					},
					required: !1
				},
				{
					type: 'select',
					labelName: '带输入筛选，排序的下拉单选',
					param: {
						name: 'updateType',
						type: 'string'
					},
					options: [
						'全部'
					],
					showSearch: true,
					filterOption: (input, option) => {
						return option.props.children.indexOf(input) >= 0;
					},
					placeholder: '升序',
					defaultValue: '',
					required: !1,
					dataApi: {
						// api: GJtypes,
						loaded: !1,
						sortMethod: 'Ascending' // 'Descending'降序；Ascending 升序； 仅对数值进行排序
					}
				},
				{
					type: 'select',
					labelName: '带输入筛选，降序下拉单选',
					param: {
						name: 'updateType2',
						type: 'string'
					},
					options: [
						'全部'
					],
					showSearch: true,
					filterOption: (input, option) => {
						return option.props.children && (option.props.children.indexOf(input) >= 0);
					},
					placeholder: '降序',
					defaultValue: '',
					required: !1,
					mapKey: {
						text: 'NAME',
						value: 'id'
					},//选中项显示取接口对应字段
					dataApi: {
						// api: stubGroupNameTips,
						loaded: true,
						sortMethod: 'Descending' // 'Descending'降序；Ascending 升序； 仅对数值进行排序
					},
					search: true,//是否自动模糊搜索
					searchParam: 'name'//自动模糊查询接口参数名
				},
				{
					type: 'select',
					selectType: 'multiple', // 可用于替代checkbox
					placeholder: '输入名称模糊查找',
					param: {
						name: 'stubGroupList',
						type: 'array',
						mapKey: 'stubGroupName',//键值对名称
						mapValue: 'stubGroupId'//键值对名称
					},//接口入参对象数组的字段名以及对象的键值对名称
					defaultValue: [],
					labelInValue: true,
					required: !0,
					labelName: '自动多选模糊搜索',
					mapKey: {
						text: 'NAME',
						value: 'id'
					},//选中项显示取接口对应字段
					dataApi: {
						// api: stubGroupNameTips,
						loaded: !0
					},
					search: true,//是否自动模糊搜索
					searchParam: 'name'//自动模糊查询接口参数名
				},
				{
					type: 'switch',
					param: {
						name: 'hasToken',
						type: 'boolean'
					},
					required: !1,
					defaultValue: !1,
					validator: { // check校验，一般用来做switch校验
						vtype: 'check'
					},
					labelName: '是否可用签名token',
					newLine: !0
				},
				{
					type: 'buttonGp', // 表单最终执行组
					buttonArr: [
						{
							btnType: 'submit',
							text: '查询',
							// icon: 'search'
						},
						{
							btnType: 'reset',
							text: '清空'
						},
						{
							btnType: 'button',
							text: '新增',
							handler: (e) => {
								console.debug(this); //当前上下文
								console.debug(e); // 暴露核心组件对象
								// 通过公共状态维护modal开关
								// 打开一个formModal
								this.context.store.dispatch(initModals('demoModal', !0));
							}
						}
					],
					newLine: !0 //是否换行
				}
			], // 设置表单元素
			layout: this.layout[ 0 ], // 设置布局 0： 横向布局， 1：纵向布局
			formTarget: 'grid', // 表单提交类型，设置grid则为更新grid
			defaultParams: { // 多个默认参数可以在这里设置，不需要使用disabled
				id: '2222',
				defaultName: '123123'
			},
			autoLoadGrid: !0, // 设置为false不触发加载grid
			context: this,
			tableKey: this.props.tableKey
		};
	}
	
	fetchApi (param) {
		// 当设置formTarget为ajax时，执行自定义提交事件。
		if (this.formConfig.formTarget === 'grid') {
			return;
		}
		// 请求fetch 对象，带入生成参数
		// 如果在modal中的表单提交，请执行这里
		if (this.props.modalSubmit) {
			return this.props.modalSubmit(param);
		} else {
			// 如果正常页面中的表单提交，请执行下面
			// TODO 执行异步请求或其他
			return;
		}
	}
	
	render () {
		return <FormCore
			formConfig={ this.formConfig }
			fetchApi={ this.fetchApi.bind(this) }
			{ ...this.props } />;
	}
	
}

export default VertForm;

VertForm.propsType = {
	layout: PropTypes.string,
	modalSubmit: PropTypes.func,
	tableKey: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/forms/vertForm.js